import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  TextField,
} from '@mui/material';

export default function MonthlyPattern({
  interval,
  onIntervalChange,
  byMonthDay,
  onByMonthDayChange,
}) {
  const { t } = useTranslation('common');

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Interval Input */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography>{t('common:rrule.pattern.every')}</Typography>
        <TextField
          type="number"
          value={interval}
          onChange={(e) => onIntervalChange(Math.max(1, parseInt(e.target.value) || 1))}
          slotProps={{ htmlInput: { min: 1, style: { textAlign: 'center' } } }}
          size="small"
          sx={{ width: 70 }}
        />
        <Typography>{t('common:rrule.pattern.every_months')}</Typography>
      </Box>

      {/* Day of month selector */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography>{t('common:rrule.pattern.on')}</Typography>
        <TextField
          type="number"
          value={byMonthDay}
          onChange={(e) => onByMonthDayChange(Math.min(31, Math.max(1, parseInt(e.target.value) || 1)))}
          slotProps={{ htmlInput: { min: 1, max: 31, style: { textAlign: 'center' } } }}
          size="small"
          sx={{ width: 70 }}
        />
      </Box>
    </Box>
  );
}
